import * as yup from "yup";

/**
 * Schema for validating account information.
 * 
 * This schema validates the following fields:
 * - `email`: Must be a valid email address and is required.
 * - `password`: Must be at least 6 characters long and is required.
 */
const accountSchema = yup.object().shape({
  email: yup
    .string()
    .email("Ungültige E-Mail")
    .required("E-Mail ist erforderlich!"),
  password: yup
    .string()
    .required("Passwort ist erforderlich!")
    .min(6, "Das Passwort muss mindestens 6 Zeichen lang sein."),
});

export default accountSchema;
